import { useCellSize } from "Components/Calendar/CalendarHelper";
import CalendarMonthView from "Components/CalendarMonth/CalendarMonthView";
import CalendarWeekView from "Components/CalendarWeek/CalendarWeekView";
import CalendarDayView from "Components/CalendarDay/CalendarDayView";
import { useCalendar } from "Components/Common/hooks/useCalendar";
import { CalendarInitializer } from "Components/Common/CalendarInitializer";
import { useAuthUser } from "Components/Auth/hooks/useAuthUser";
import { useIsInternalAdmin } from "Components/Members/hooks/useIsInternalAdmin";
import { useInitModals } from "Components/Modal/hooks/useInitModals";
import { CalendarType } from "Components/Navigation/NavigationHelper";
import NavigationView from "Components/Navigation/NavigationView";
import { useSubscribeToProfileLimits, useProfileLimits } from "Components/ProfileLimit/hooks/useProfileLimits";
import { getIsDayViewEnabled } from "Components/ProfileLimit/helpers/getIsDayViewEnabled";
import { useSubscribeToProjects } from "Components/Project/hooks/useSubscribeToProjects";
import QuickAddMenuView from "Components/QuickAdd/QuickAddMenuView";
import { useSubscribeToSchedule } from "Components/Schedule/hooks/useSchedule";
import ScheduleEntryModal from "Components/ScheduleEntry/ScheduleEntryModal";
import { useSubscribeToScheduleEntries } from "Components/ScheduleEntry/hooks/useScheduleEntries";
import { useSubscribeToDayScheduleEntries } from "Components/ScheduleEntry/hooks/useDayScheduleEntries";
import { useInitDefaultScheduleEntryTypes } from "Components/ScheduleEntryType/ScheduleEntryTypeHelper";
import { useSubscribeToScheduleEntryTypes } from "Components/ScheduleEntryType/hooks/useScheduleEntryTypes";
import SchedulePhaseModal from "Components/SchedulePhase/SchedulePhaseModal";
import { useSubscribeToSchedulePhases } from "Components/SchedulePhase/hooks/useSchedulePhases";
import ScheduleResourceModal from "Components/ScheduleResource/ScheduleResourceModal";
import { useSubscribeToScheduleResources } from "Components/ScheduleResource/hooks/useScheduleResources";
import TeamsModal from "Components/Team/TeamsModal";
import TutorialModal from "Components/Tutorial/TutorialModal";
import WorkingHoursModal from "Components/WorkingHours/WorkingHoursModal";
import { useIsBrowserOrIpadOs } from "Helpers/PlatformHelper";
import React, { FC, Fragment } from "react";

const AppView: FC = () => {
	const cellSize = useCellSize();
	const calendarType = useCalendar((state) => state.calendarType);
	const isBrowserOrIpadOs = useIsBrowserOrIpadOs();
	const isInternalAdmin = useIsInternalAdmin();
	const userId = useAuthUser((state) => state.user?.uid);
	const profileLimits = useProfileLimits((state) => state.items);

	useInitDefaultScheduleEntryTypes();
	useInitModals();

	// Subscribe to both week and day entries
	useSubscribeToScheduleEntries();
	useSubscribeToDayScheduleEntries();
	
	// Profile limits are now subscribed in AuthView before InitializationProvider
	useSubscribeToScheduleResources();
	useSubscribeToProjects();
	useSubscribeToSchedulePhases();
	useSubscribeToScheduleEntryTypes();
	useSubscribeToSchedule();


	return (
		<Fragment>
			<CalendarInitializer />
			<NavigationView cellSize={cellSize} />
			{calendarType === CalendarType.DAY && userId && getIsDayViewEnabled(userId, profileLimits) && (
				<CalendarDayView cellSize={cellSize} />
			)}
			{calendarType === CalendarType.WEEK && (
				<CalendarWeekView cellSize={cellSize} />
			)}
			{calendarType === CalendarType.MONTH && (
				<CalendarMonthView cellSize={cellSize} />
			)}
			{isInternalAdmin && isBrowserOrIpadOs && (
				<QuickAddMenuView cellSize={cellSize} calendarType={calendarType} />
			)}
			<ScheduleEntryModal />
			<TeamsModal />
			<TutorialModal />
			<ScheduleResourceModal />
			<SchedulePhaseModal />
			<WorkingHoursModal />
		</Fragment>
	);
};

export default AppView;
